import { lazy, memo, Suspense } from 'react';
import { LucideProps } from 'lucide-react';
import dynamicIconImports from 'lucide-react/dynamicIconImports';

const fallback = <div style={{ background: '#ddd', width: 24, height: 24 }} />;

interface IconProps extends Omit<LucideProps, 'ref'> {
  nombre: keyof typeof dynamicIconImports;
}

const IconoDinamico = memo(function IconoDinamico({
  nombre,
  ...props
}: IconProps) {
  const ImportIcono = dynamicIconImports[nombre];

  if (!ImportIcono) {
    return null;
  }

  const RenderizarIcono = lazy(ImportIcono);

  return (
    <Suspense fallback={fallback}>
      <RenderizarIcono {...props} />
    </Suspense>
  );
});

export default IconoDinamico;
